import { Pipe, PipeTransform } from '@angular/core';
import { FunnelColorTable } from '../../../root/job-opportunity-application/job-opportunity-step-colors.service';

@Pipe({
  name: 'colorCode',
  standalone: false,
})
export class ColorCodePipe implements PipeTransform {
  transform(
    value: {
      name: string;
      stepType: number;
    },
    colorTable: FunnelColorTable,
  ): string {
    const color = colorTable.find((s) => s.type === value.stepType && s.text === value.name);

    return color?.color ?? '';
  }
}
